import { Tooltip as PrimerTooltip, TooltipProps as PrimerTooltipProps } from '@primer/react';

type Props = {} & PrimerTooltipProps;

const Tooltip = ({ ...props }: Props) => <PrimerTooltip {...props} />;

export default Tooltip;
export type { Props as TooltipProps };
